// extracted by mini-css-extract-plugin
export var modal_button = "restore-password-module--modal_button--aj092";
export var recover_description = "restore-password-module--recover_description--Jv4Tg";
export var recover_head = "restore-password-module--recover_head--1FtGn";